var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareProductProspector = function SvgYeswareProductProspector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 12,
    fill: "#ECF7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.172 28.343a9.132 9.132 0 0 0 5.803-2.071l5.47 5.47a.917.917 0 0 0 1.298-1.296l-5.472-5.471a9.172 9.172 0 0 0-11.03-14.09 9.17 9.17 0 0 0 3.931 17.458Zm-2.75-10.089h1.834V16.42a.917.917 0 1 1 1.834 0v1.834h1.834a.917.917 0 0 1 0 1.834H20.09v1.835a.917.917 0 1 1-1.834 0v-1.834H16.42a.917.917 0 1 1 0-1.835Z",
    fill: "#29ABE2"
  })));
};
export default SvgYeswareProductProspector;